import {ofType} from 'redux-observable';
import {Observable} from 'rxjs';
import {flatMap, filter} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import {conversationIdFromNotification} from 'web-app/react/notifications/helpers';
import InboxApi from 'web-app/api/inbox-api';
import * as NotificationActions from 'web-app/react/notifications/actions';
import {hasValue} from '@famly/stat_ts-utils_has-value';

import * as Actions from './actions';
import {inboxType, archived} from './selectors';

const fetchObservable = (successAction, offset = 0, inboxType, archived) =>
    InboxApi.fetchInboxConversationsObservable(10, offset, inboxType, archived).map(response =>
        successAction(response),
    );

const fetch = action$ =>
    action$
        .ofType(Actions.fetch.type)
        .mergeMap(({payload}) =>
            fetchObservable(Actions.fetchSuccess.action, undefined, payload.type, payload.archived).catch(e =>
                Observable.of(Actions.fetchFailed.action(e)),
            ),
        );

const fetchMore = action$ =>
    action$
        .ofType(Actions.fetchMore.type)
        .mergeMap(({payload}) =>
            fetchObservable(Actions.fetchMoreSuccess.action, payload.offset, payload.type, payload.archived).catch(e =>
                Observable.of(Actions.fetchMoreFailed.action(e)),
            ),
        );

const fetchOnInboxType = (action$, state$) =>
    action$.ofType(Actions.setInboxType.type).mergeMap(() => {
        const state = state$.value;
        const type = inboxType(state);
        const isArchived = archived(state);

        return fetchObservable(Actions.fetchSuccess.action, undefined, type, isArchived).takeUntil(
            action$.ofType(Actions.setInboxType.type),
        );
    });

const updateAndBumpConversationFromPush = (action$, state$) =>
    action$.pipe(
        ofType(NotificationActions.didReceiveNotification.type),
        filter(({payload}) => payload.notification && hasValue(conversationIdFromNotification(payload.notification))),
        flatMap(({payload}) => {
            /*
                See API for "event" object here
                https://github.com/phonegap/phonegap-plugin-push/blob/master/docs/API.md#pushonnotification-callback
            */
            return fetchObservable(
                conversationsFromAPI => {
                    const conversation = conversationsFromAPI.find(
                        candidateConversation =>
                            candidateConversation.conversationId ===
                            conversationIdFromNotification(payload.notification),
                    );
                    if (hasValue(conversation)) {
                        return Actions.updateAndBumpConversation.action(conversation);
                    }
                    // Since fetchObservable expects an action we return a dummy one
                    return Actions.noop.action();
                },
                undefined,
                inboxType(state$.value),
                archived(state$.value),
            );
        }),
    );

export default combineEpics(fetch, fetchMore, fetchOnInboxType, updateAndBumpConversationFromPush);
